export const appRoutes = {
  home: "/",
  about: "/despre",
  aboutLegislation: "/despre-legislatia",
  dsuNumbers: "/DSU-in-cifre",
  news: "/stiri-si-media",
  dialog: "/dialog-civic",
  map: "/harta",
  contact: "/contact",
  legislation: "/legislatie",
  legislationDetails: "/legislatie-detalii",
  legislationEvents: "/legislatie-evenimente",
  legislationOrders: "/legislatie-ordine",
  legislationConsults: "/legislatie-consultari",
  legislationDecisions: "/legislatie-hotarari",
  legislationWindow: "/legislatie-ghiseu",
  legislationOrganisation: "/legislatia-organizatiei",
  legislationRegulations: "/regulamente-organizare",
  gdpr: "/gdpr",
  officials: "/comunicate-oficiale",
  officialsDetails: "/comunicate-oficiale/",
  agenda: "/agenda",
  newsAndPartners: "/stiri-si-parteneri",
  newsAndPartnersDetails: "/stiri-si-parteneri/",
  campaigns: "/campanii",
  campaignsDetails: "/campanii/",
  events: "/evenimente",
  newsletter: "/buletine-informative",
  projects: "/proiecte",
  emergencyCommunication: "/comunicat-de-urgenta/",
  projectDetails: "/proiect-detalii/",
  eventDetails: "/eveniment-detalii/",
  institutionsContact: "/contact-institutii",
  cookies: "/cookies",
  partners: "/parteneri",
  activityReports: "/rapoarte-de-activitate",
  qualityManagement: "/managementul-calitatii",
  campaignArchive: "/arhiva-campanii",
  search: "/cautare",
};
